﻿(function() {
    "use strict";

    angular
        .module("app")
        .component("imgCover", {
            bindings: {
                src: "=",
                style: "@"
            },
            templateUrl: ['version', function(version) {
                return `/js/components/imgCover/img-cover.html?v=${version}`
            }],
        }).config(["$sceDelegateProvider", function($sceDelegateProvider) {
            $sceDelegateProvider.resourceUrlWhitelist([
                'self',
                // Allow loading from our assets domain.
                'https://staging-synkedup-public.s3.amazonaws.com/**',
                'https://staging-synkedup-private.s3.amazonaws.com/**',
                'https://synkedup-public.s3.amazonaws.com/**',
                'https://synkedup-private.s3.amazonaws.com/**',
            ]);
        }]);
})();
